/**
 * Asynchronously loads the component for NotFoundPage
 */

import * as React from 'react';
import { lazyLoad } from 'utils/loadable';
import { LoadingIndicator } from 'app/components/LoadingIndicator';

export const Blog = lazyLoad(
  () => import('./index'),
  module => module.Blog,
  {
    fallback: <LoadingIndicator />,
  },
);
